export default {
	'view-details': 'Ver detalles'
}